<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html
  lang="en"
  xmlns="http://www.w3.org/1999/xhtml"
  xmlns:v="urn:schemas-microsoft-com:vml"
  xmlns:o="urn:schemas-microsoft-com:office:office"
>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="x-apple-disable-message-reformatting" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <title></title>
    <link
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap"
      rel="stylesheet"
    />
  </head>

  <body
    class="clean-body u_body"
    style="
      margin: 0;
      padding: 5%;
      -webkit-text-size-adjust: 100%;
      background-image: url(assets/bg.jpg);
      background-size: cover;
      color: #000000;
    "
  >
    <table
      id="u_body"
      style="
        border-collapse: collapse;
        table-layout: fixed;
        border-spacing: 0;
        mso-table-lspace: 0pt;
        mso-table-rspace: 0pt;
        vertical-align: middle;
        min-width: 320px;
        margin: 0 auto;
        width: 100%;
      "
    >
      <caption style="display: none">
        2FA
      </caption>
      <thead style="display: none">
        <tr>
          <th>Header 1</th>
        </tr>
      </thead>
      <tbody>
        <tr style="vertical-align: middle">
          <td
            style="
              word-break: break-word;
              border-collapse: collapse !important;
              vertical-align: top;
            "
          >
            <div
              class="u-row-container"
              style="padding: 0px; background-color: transparent"
            >
              <div
                class="u-row"
                style="
                  margin: 0 auto;
                  min-width: 320px;
                  max-width: 600px;
                  overflow-wrap: break-word;
                  word-wrap: break-word;
                  word-break: break-word;
                  background-color: transparent;
                "
              >
                <div
                  style="
                    border-collapse: collapse;
                    display: table;
                    width: 100%;
                    height: 100%;
                    background-repeat: no-repeat;
                    background-position: center top;
                    background-color: transparent;
                  "
                >
                  <div
                    class="u-col u-col-100"
                    style="
                      max-width: 320px;
                      min-width: 600px;
                      display: table-cell;
                      vertical-align: top;
                    "
                  >
                    <div
                      style="
                        height: 100%;
                        width: 100% !important;
                        border-radius: 0px;
                        -webkit-border-radius: 0px;
                        -moz-border-radius: 0px;
                      "
                    >
                      <div
                        style="
                          height: 100%;
                          padding: 0px;
                          border-top: 0px solid transparent;
                          border-left: 0px solid transparent;
                          border-right: 0px solid transparent;
                          border-bottom: 0px solid transparent;
                          border-radius: 0px;
                          -webkit-border-radius: 0px;
                          -moz-border-radius: 0px;
                        "
                      >
                        <table
                          id="u_content_text_6"
                          style="font-family: 'Poppins', sans-serif;"
                        >
                        <caption style="display: none">
                          2FA
                        </caption>
                        <thead style="display: none">
                          <tr>
                            <th>heading 1</th>
                          </tr>
                        </thead>
                          <tbody>
                            <tr>
                              <td style="padding-top: 10%"></td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          id="u_content_heading_2"
                          style="font-family: 'Poppins', sans-serif"
                          text-align="left"
                        >
                        <caption style="display: none">
                          2FA
                        </caption>
                        <thead style="display: none">
                          <tr>
                            <th>heading 2</th>
                          </tr>
                        </thead>
                          <tbody>
                            <tr>
                              <td
                                class="v-container-padding-padding"
                                style="
                                  overflow-wrap: break-word;
                                  word-break: break-word;
                                  padding: 60px 60px 20px 60px;
                                  font-family: 'Open Sans', sans-serif;
                                "
                                text-align="left"
                              >
                                <span
                                  style="padding-bottom: 25px; display: block"
                                  ><img
                                    src="assets/verify-email.svg"
                                    alt="email-icon"
                                /></span>
                                <h1
                                  class="v-font-size"
                                  style="
                                    margin: 0px;
                                    color: #ffffff;
                                    text-align: left;
                                    word-wrap: break-word;
                                    font-family: 'Poppins', sans-serif;
                                    font-size: 32px;
                                    text-transform: uppercase;
                                    font-weight: 300;
                                    line-height: 1.2;
                                  "
                                >
                                  OTP VERIFICATION
                                </h1>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          id="u_content_text_2"
                          style="font-family: 'Open Sans', sans-serif"
                        >
                          <caption style="display: none">
                            2FA
                          </caption>
                          <thead style="display: none">
                            <tr>
                              <th>Header 2</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                class="v-container-padding-padding"
                                style="
                                  overflow-wrap: break-word;
                                  word-break: break-word;
                                  padding: 10px 60px;
                                  font-family: 'Poppins', sans-serif;
                                "
                                text-align="left"
                              >
                                <div class="otp-field mb-4">
                                  <table>
                                    <caption style="display: none">
                                      2FA
                                    </caption>
                                    <thead style="display: none">
                                      <tr>
                                        <th>Header 2</th>
                                      </tr>
                                    </thead>
                                    <tr>
                                      <td id="table_align">
                                        <input
                                          type="text"
                                          class="otp-box"
                                          maxlength="1"
                                          id="otp1"
                                          [(ngModel)]="otpValues[0]"
                                          (keydown)="onKeyDown($event, 0)"
                                          #otpInput
                                        />
                                      </td>
                                      <td id="table_align">
                                        <input
                                          type="text"
                                          class="otp-box"
                                          maxlength="1"
                                          id="otp2"
                                          [(ngModel)]="otpValues[1]"
                                          (keydown)="onKeyDown($event, 1)"
                                          #otpInput
                                        />
                                      </td>
                                      <td id="table_align">
                                        <input
                                          type="text"
                                          class="otp-box"
                                          maxlength="1"
                                          id="otp3"
                                          [(ngModel)]="otpValues[2]"
                                          (keydown)="onKeyDown($event, 2)"
                                          #otpInput
                                        />
                                      </td>
                                      <td id="table_align">
                                        <input
                                          type="text"
                                          class="otp-box"
                                          maxlength="1"
                                          id="otp4"
                                          [(ngModel)]="otpValues[3]"
                                          (keydown)="onKeyDown($event, 3)"
                                          #otpInput
                                        />
                                      </td>
                                      <td id="table_align">
                                        <input
                                          type="text"
                                          class="otp-box"
                                          maxlength="1"
                                          id="otp5"
                                          [(ngModel)]="otpValues[4]"
                                          (keydown)="onKeyDown($event, 4)"
                                          #otpInput
                                        />
                                      </td>
                                      <td id="table_align">
                                        <input
                                          type="text"
                                          class="otp-box"
                                          maxlength="1"
                                          id="otp6"
                                          [(ngModel)]="otpValues[5]"
                                          (keydown)="onKeyDown($event, 5)"
                                          #otpInput
                                        />
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          id="u_content_button_4"
                          style="font-family: 'Poppins', sans-serif"
                        >
                        <caption style="display: none">
                          2FA
                        </caption>
                        <thead style="display: none">
                          <tr>
                            <th>heading 3</th>
                          </tr>
                        </thead>
                          <tbody>
                            <tr>
                              <td
                                class="v-container-padding-padding"
                                style="
                                  overflow-wrap: break-word;
                                  word-break: break-word;
                                  padding: 40px 10px 30px;
                                  font-family: 'Poppins', sans-serif;
                                "
                                text-align="left"
                              >
                                <div id="table_align">
                                  <span
                                    class="alert-message"
                                    *ngIf="errorString"
                                    >{{ errorString }}</span
                                  >
                                  <a
                                    (click)="onSubmit()"
                                    target="_blank"
                                    class="v-button v-size-width"
                                    style="
                                      box-sizing: border-box;
                                      display: inline-block;
                                      font-family: 'Poppins', sans-serif;
                                      text-decoration: none;
                                      -webkit-text-size-adjust: none;
                                      text-align: center;
                                      color: #000000;
                                      background-color: #ffd958;
                                      border-radius: 2px;
                                      -webkit-border-radius: 2px;
                                      -moz-border-radius: 2px;
                                      width: 82%;
                                      max-width: 100%;
                                      overflow-wrap: break-word;
                                      word-break: break-word;
                                      word-wrap: break-word;
                                      mso-border-alt: none;
                                    "
                                  >
                                    <span
                                      style="
                                        display: block;
                                        padding: 20px 20px;
                                        line-height: 120%;
                                      "
                                      ><strong
                                        ><span
                                        *ngIf="!isSubmitting"
                                          style="
                                            font-size: 14px;
                                            line-height: 16.8px;
                                            text-transform: uppercase;
                                          "
                                          >VERIFY</span
                                        >
                                        <span *ngIf="isSubmitting" class="spinner-border sr-only" role="status"></span></strong
                                      ></span
                                    >
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          id="u_content_text_6"
                          style="font-family: 'Poppins', sans-serif"
                        >
                        <caption style="display: none">
                          2FA
                        </caption>
                        <thead style="display: none">
                          <tr>
                            <th>heading 4</th>
                          </tr>
                        </thead>
                          <tbody>
                            <tr>
                              <td style="height: 50px"></td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          id="u_content_text_6"
                          style="font-family: 'Open Sans', sans-serif"
                        >
                          <caption style="display: none">
                            2FA
                          </caption>
                          <thead style="display: none">
                            <tr>
                              <th>Header 3</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                class="v-container-padding-padding"
                                style="
                                  overflow-wrap: break-word;
                                  word-break: break-word;
                                  padding: 60px 10px 10px;
                                  font-family: 'Open Sans', sans-serif;
                                "
                                text-align="left"
                              >
                                <div id="table_align">
                                  <div style="display: table; max-width: 167px">
                                    <table
                                      text-align="left"
                                      border="0"
                                      id="table_width"
                                      height="32"
                                      style="
                                        width: 32px !important;
                                        height: 32px !important;
                                        display: inline-block;
                                        border-collapse: collapse;
                                        table-layout: fixed;
                                        border-spacing: 0;
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                        vertical-align: top;
                                        margin-right: 10px;
                                      "
                                    >
                                    <caption style="display: none">
                                      2FA
                                    </caption>
                                    <thead style="display: none">
                                      <tr>
                                        <th>heading 5</th>
                                      </tr>
                                    </thead>
                                      <tbody>
                                        <tr style="vertical-align: top">
                                          <td
                                            text-align="left"
                                            style="
                                              word-break: break-word;
                                              border-collapse: collapse !important;
                                              vertical-align: top;
                                            "
                                          >
                                            <a
                                              href="#"
                                              title="Facebook"
                                              target="_blank"
                                            >
                                              <img
                                                src="assets/image-4.png"
                                                alt="Facebook"
                                                title="Facebook"
                                                width="32"
                                                style="
                                                  outline: none;
                                                  text-decoration: none;
                                                  -ms-interpolation-mode: bicubic;
                                                  clear: both;
                                                  display: block !important;
                                                  border: none;
                                                  height: auto;
                                                  float: none;
                                                  max-width: 32px !important;
                                                "
                                              />
                                            </a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table
                                      text-align="left"
                                      border="0"
                                      id="table_width"
                                      height="32"
                                      style="
                                        width: 32px !important;
                                        height: 32px !important;
                                        display: inline-block;
                                        border-collapse: collapse;
                                        table-layout: fixed;
                                        border-spacing: 0;
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                        vertical-align: top;
                                        margin-right: 10px;
                                      "
                                    >
                                    <caption style="display: none">
                                      2FA
                                    </caption>
                                    <thead style="display: none">
                                      <tr>
                                        <th>heading 5</th>
                                      </tr>
                                    </thead>
                                      <tbody>
                                        <tr style="vertical-align: top">
                                          <td
                                            text-align="left"
                                            style="
                                              word-break: break-word;
                                              border-collapse: collapse !important;
                                              vertical-align: top;
                                            "
                                          >
                                            <a
                                              href="#"
                                              title="Twitter"
                                              target="_blank"
                                            >
                                              <img
                                                src="assets/image-3.png"
                                                alt="Twitter"
                                                title="Twitter"
                                                width="32"
                                                style="
                                                  outline: none;
                                                  text-decoration: none;
                                                  -ms-interpolation-mode: bicubic;
                                                  clear: both;
                                                  display: block !important;
                                                  border: none;
                                                  height: auto;
                                                  float: none;
                                                  max-width: 32px !important;
                                                "
                                              />
                                            </a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table
                                      text-align="left"
                                      border="0"
                                      id="table_width"
                                      height="32"
                                      style="
                                        width: 32px !important;
                                        height: 32px !important;
                                        display: inline-block;
                                        border-collapse: collapse;
                                        table-layout: fixed;
                                        border-spacing: 0;
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                        vertical-align: top;
                                        margin-right: 10px;
                                      "
                                    >
                                    <caption style="display: none">
                                      2FA
                                    </caption>
                                    <thead style="display: none">
                                      <tr>
                                        <th>heading 5</th>
                                      </tr>
                                    </thead>

                                      <tbody>
                                        <tr style="vertical-align: top">
                                          <td
                                            text-align="left"
                                            style="
                                              word-break: break-word;
                                              border-collapse: collapse !important;
                                              vertical-align: top;
                                            "
                                          >
                                            <a
                                              href="#"
                                              title="LinkedIn"
                                              target="_blank"
                                            >
                                              <img
                                                src="assets/image-6.png"
                                                alt="LinkedIn"
                                                title="LinkedIn"
                                                width="32"
                                                style="
                                                  outline: none;
                                                  text-decoration: none;
                                                  -ms-interpolation-mode: bicubic;
                                                  clear: both;
                                                  display: block !important;
                                                  border: none;
                                                  height: auto;
                                                  float: none;
                                                  max-width: 32px !important;
                                                "
                                              />
                                            </a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <table
                                      text-align="left"
                                      border="0"
                                      id="table_width"
                                      height="32"
                                      style="
                                        width: 32px !important;
                                        height: 32px !important;
                                        display: inline-block;
                                        border-collapse: collapse;
                                        table-layout: fixed;
                                        border-spacing: 0;
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                        vertical-align: top;
                                        margin-right: 0px;
                                      "
                                    >
                                    <caption style="display: none">
                                      2FA
                                    </caption>
                                    <thead style="display: none">
                                      <tr>
                                        <th>heading 4</th>
                                      </tr>
                                    </thead>
                                      <tbody>
                                        <tr style="vertical-align: top">
                                          <td
                                            text-align="left"
                                            style="
                                              word-break: break-word;
                                              border-collapse: collapse !important;
                                              vertical-align: top;
                                            "
                                          >
                                            <a
                                              href="#"
                                              title="Instagram"
                                              target="_blank"
                                            >
                                              <img
                                                src="assets/image-5.png"
                                                alt="Instagram"
                                                title="Instagram"
                                                width="32"
                                                style="
                                                  outline: none;
                                                  text-decoration: none;
                                                  -ms-interpolation-mode: bicubic;
                                                  clear: both;
                                                  display: block !important;
                                                  border: none;
                                                  height: auto;
                                                  float: none;
                                                  max-width: 32px !important;
                                                "
                                              />
                                            </a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          id="u_content_text_6"
                          style="font-family: 'Open Sans', sans-serif"
                        >
                          <caption style="display: none">
                            2FA
                          </caption>
                          <thead style="display: none">
                            <tr>
                              <th>Header 6</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                class="v-container-padding-padding"
                                style="
                                  overflow-wrap: break-word;
                                  word-break: break-word;
                                  padding: 10px 100px 60px;
                                  font-family: 'Open Sans', sans-serif;
                                  color: #ffffff;
                                "
                                text-align="left"
                              >
                                <div
                                  class="v-text-align v-line-height"
                                  style="
                                    line-height: 170%;
                                    text-align: center;
                                    word-wrap: break-word;
                                  "
                                >
                                  <p style="font-size: 14px; line-height: 170%">
                                    UNSUBSCRIBE | PRIVACY POLICY | WEB
                                  </p>
                                  <p
                                    style="font-size: 14px; line-height: 170%"
                                  ></p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </body>
</html>
